import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/bierling1712.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
    	<var>Die philophischen schriften von Gottfried Wilheim Leibniz, vol. VII</var><br />
		C. I. Gerhardt (ed)<br />
		pp 502-503<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		Date: 14 January 1712<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (86k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Friedrich Wilhelm Bierling (14 January 1712)</title>
            <meta name="description" content="An English translation of a LETTER TO FRIEDRICH WILHELM BIERLING by Gottfried Wilhelm Leibniz, from 14 January 1712" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO FRIEDRICH WILHELM BIERLING</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>G VII 502</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;While looking over my letters I see that I still owe you a reply, so I did not wish to delay any longer. You had assigned light to the spiritual, and denied that resistance—which to me is an indication of its corporeality—could be conceived in it. But what, I ask, are refractions and reflections if not the effects of resistance? That such things could be spiritual is a fiction of certain modern authors philosophising rather crudely. [<b>G VII 503</b>]  But active light is no more than a jet of water, except that light is more subtle and moves more swiftly. Lastly, it is objected that matter is not active in itself. What then? It is sufficient that it be active once motion has been impressed upon it. There is no doubt that, as soon as it was created, it was set in motion, and that the force once received is always retained, for no force is ever lost, but only transferred, dispersed, or collected. Nor does light compel us to have recourse to atoms any more than any other fluid whatever. Nor do monads have shape any more than do souls, nor are they parts of bodies, but requisites for them.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;My essay on <var>Theodicy</var> is also rare here; the copies soon disappeared, and I am sometimes forced to give away my own copies to those asking for one, so that now I have virtually none left.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;What the theologians of Halle have thought of this work I have not yet seen, for, as far as I know, our bookseller does not have their books. It has been received with greater applause than I expected by theologians of the three religions of the empire. What remains is to bid you farewell and to commend myself to your favour. Written at Hanover, 14 January 1712.<br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;P. S. Thomas Burnett's <var>Sacred Theory of the Earth</var> is ingenious and learned, and there can be no doubt that the crust of our earth consists of ruins. This, then, is right in the main, but with regard to the hypothesis itself, when you examine it more closely, you will find many things that do not seem able to stand firm.
        <br /><br /><br />
                &#169; Lloyd Strickland 2005. Revised 2025<br />
                With gratitude to John Thorley for advice and suggestions
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
